import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class StateService {

  stateBS: BehaviorSubject<State> = new BehaviorSubject<State>({recent_lookups: []})
  stateObservable: Observable<State>;

  lookupBS: BehaviorSubject<string> = new BehaviorSubject("");
  lookupObservable: Observable<string>;

  constructor() {
    this.init()

    this.stateObservable = this.stateBS.asObservable();
    this.lookupObservable = this.lookupBS.asObservable();

    this.stateObservable.subscribe((state) => {
      localStorage.setItem('state', JSON.stringify(state));
    });

    this.lookupObservable.subscribe((state) => {
      if (state.length > 0) {
        this.add_recent_lookup(state)
      }
    });
  }

  init() {
    let localState: State;
    try {
      localState = JSON.parse(localStorage.getItem('state') ?? '{recent_lookups:[]}');
    } catch (e) {
      localState = {
        recent_lookups: [],
      }
    }
    this.stateBS.next(localState);
  }

  add_recent_lookup(lookup: string) {
    if (lookup.length > 0) {
      let state = this.stateBS.getValue()
      if (state.recent_lookups.includes(lookup)) {
        state.recent_lookups = state.recent_lookups.filter(s => s != lookup);
      }

      state.recent_lookups = [lookup, ...state.recent_lookups];

      if (state.recent_lookups.length >= 10) {
        state.recent_lookups.pop();
      }
      this.stateBS.next(state);
    }
  }
}

export interface State {
  recent_lookups: string[]
}
